const defaultState = {
  productsInCart: 0,
  productList: [],
  productsMeta: {},
  uploadedGraphicImage: {
    src: null,
    filename: "",
  },
  uploadedNotecardImage: {
    src: {},
    filename: "",
  },
  previewImageSRC: { src: {}, filename: "" },
  graphicURL: "",
  notecardURL: "",
  productSearched: false,
  productStats: {},
  personalized_variations: [],
  graphicSwitches: [],
  etsySKUBeforeCreation: [],
  amazonSKUBeforeCreation: null,
  etsyListings: [],
  etsyListing: {},
  etsyListingsLoading: false,
  etsyListingsBatchLoading: false,
  lastEtsyOffset: 0,
  etsyResyncLoading: false,
  // Separate states for each status
  etsyListingsActive: [],
  etsyListingsInactive: [],
  etsyListingsDraft: [],
  etsyListingsActiveLoading: false,
  etsyListingsInactiveLoading: false,
  etsyListingsDraftLoading: false,
  etsyResyncActiveLoading: false,
  etsyResyncInactiveLoading: false,
  etsyResyncDraftLoading: false,
  // Current tab status for Etsy listings
  currentEtsyTabStatus: "1", // Default to active tab
};

const productReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "addTocart": {
      const count = Number(action.payload);
      return {
        ...state,
        productsInCart: Number.isFinite(count) ? Math.max(0, count) : 0,
      };
    }

    case "setProductsList":
      return {
        ...state,
        productList: action.payload,
      };

    case "setProductsMeta":
      return {
        ...state,
        productsMeta: action.payload,
      };

    case "setProductSearched":
      return {
        ...state,
        productSearched: action.payload,
      };

    case "setGraphicSwitches":
      return {
        ...state,
        graphicSwitches: action.payload,
      };

    case "setUploadedGraphicImage":
      return {
        ...state,
        uploadedGraphicImage: {
          src: action.payload.src,
          filename: action.payload.filename,
        },
      };

    case "setUploadedNotecardImage":
      return {
        ...state,
        uploadedNotecardImage: {
          src: action.payload.src,
          filename: action.payload.filename,
        },
      };

    case "setPreviewImageSRC":
      return {
        ...state,
        previewImageSRC: {
          src: action.payload.src,
          filename: action.payload.filename,
        },
      };

    case "setGraphicURL":
      return {
        ...state,
        graphicURL: action.payload,
      };

    case "setNotecardURL":
      return {
        ...state,
        notecardURL: action.payload,
      };

    case "setProductStats":
      return {
        ...state,
        productStats: action.payload,
      };

    case "setPersonalizedVariations":
      return {
        ...state,
        personalized_variations: action.payload,
      };

    case "clearPersonalizedVariations":
      return {
        ...state,
        personalized_variations: [],
      };

    case "setEtsySKUBeforeCreation":
      if (
        action.merge &&
        state.etsySKUBeforeCreation?.skus &&
        action.payload?.skus
      ) {
        // Merge SKUs: combine existing SKUs with new SKUs, avoiding duplicates
        const existingSkuIds = state.etsySKUBeforeCreation.skus.map(
          (sku) => sku.sku
        );
        const newSkus = action.payload.skus.filter(
          (sku) => !existingSkuIds.includes(sku.sku)
        );
        const mergedSkus = [...state.etsySKUBeforeCreation.skus, ...newSkus];

        return {
          ...state,
          etsySKUBeforeCreation: {
            // Preserve the original listing_id and other properties from existing state
            ...state.etsySKUBeforeCreation,
            // Only update the skus array
            skus: mergedSkus,
          },
        };
      } else {
        // Replace entire payload (original behavior)
        return {
          ...state,
          etsySKUBeforeCreation: action.payload,
        };
      }

    case "setAmazonSKUBeforeCreation":
      return {
        ...state,
        amazonSKUBeforeCreation: action.payload,
      };

    case "clearAmazonSKUBeforeCreation":
      return {
        ...state,
        amazonSKUBeforeCreation: null,
      };

    case "setEtsyListings":
      return {
        ...state,
        etsyListings: action.payload,
      };

    case "setEtsyListing":
      return {
        ...state,
        etsyListing: action.payload,
      };

    case "setEtsyListingsLoading":
      return {
        ...state,
        etsyListingsLoading: action.payload,
      };

    case "setEtsyListingsBatchLoading":
      return {
        ...state,
        etsyListingsBatchLoading: action.payload,
      };

    case "appendEtsyListings":
      return {
        ...state,
        etsyListings: [...state.etsyListings, ...action.payload],
      };

    case "clearEtsyListings":
      return {
        ...state,
        etsyListings: [],
      };

    case "setLastEtsyOffset":
      return {
        ...state,
        lastEtsyOffset: action.payload,
      };

    case "setEtsyResyncLoading":
      return {
        ...state,
        etsyResyncLoading: action.payload,
      };

    // Active listings
    case "setEtsyListingsActive":
      return {
        ...state,
        etsyListingsActive: action.payload,
      };

    case "setEtsyListingsActiveLoading":
      return {
        ...state,
        etsyListingsActiveLoading: action.payload,
      };

    case "setEtsyResyncActiveLoading":
      return {
        ...state,
        etsyResyncActiveLoading: action.payload,
      };

    // Inactive listings
    case "setEtsyListingsInactive":
      return {
        ...state,
        etsyListingsInactive: action.payload,
      };

    case "setEtsyListingsInactiveLoading":
      return {
        ...state,
        etsyListingsInactiveLoading: action.payload,
      };

    case "setEtsyResyncInactiveLoading":
      return {
        ...state,
        etsyResyncInactiveLoading: action.payload,
      };

    // Draft listings
    case "setEtsyListingsDraft":
      return {
        ...state,
        etsyListingsDraft: action.payload,
      };

    case "setEtsyListingsDraftLoading":
      return {
        ...state,
        etsyListingsDraftLoading: action.payload,
      };

    case "setEtsyResyncDraftLoading":
      return {
        ...state,
        etsyResyncDraftLoading: action.payload,
      };

    // Current tab status
    case "setCurrentEtsyTabStatus":
      return {
        ...state,
        currentEtsyTabStatus: action.payload,
      };

    default:
      return state;
  }
};

export default productReducer;
